module.exports = __webpack_public_path__ + "img/43.6a2c45a5.png";